import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../api/request';
import {
  getSectionCourseOfGradeEntry,
  TeachaerSectionCourseOfGradeEntry,
} from '../../../api/requests/gradeEntry';
import { createFetchContext } from '../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../components/Info/DisplayError';
import Loading from '../../../components/Info/Loading';

export type AuthenticationError = {
  code: 'AUTHENTICATION';
  error: any;
  status: number;
  data?: any;
};

export interface AddEvaluationGradeEntryLoaderProps {
  sectionId: string;
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  TeachaerSectionCourseOfGradeEntry,
  AuthenticationError | AxiosResultDefaultError
>();

export const AddEvaluationGradeEntryLoaderConsumer = FetchConsumer;

export const useAddEvaluationGradeEntry = useFetch;

export function useStudentAcademicHistory2() {
  return useFetch();
}

export default function AddEvaluationGradeEntryLoader({
  sectionId,
  children,
}: AddEvaluationGradeEntryLoaderProps) {
  const request = useCallback(async () => {
    const response = await getSectionCourseOfGradeEntry(sectionId);
    if (response.error) {
      return { error: response.error };
    }
    return { data: response.data };
  }, [sectionId]);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return <Loading insideCard />;
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          return children;
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
